// extracted by mini-css-extract-plugin
export default {"options":"SocialOptions_options__C9j8o","btnMakeDonation":"SocialOptions_btnMakeDonation__xj3MT","icon":"SocialOptions_icon__3sUlb"};